export default {
    data() {
        return {
            TotalCateList: [],
            SelCateList: [
                [],
                [],
                [],
                []
            ],
            cateValue: [
              [],
              [],
              [],
              []
            ],
        }
    },
    methods: {
        getCateValue() {
          let txt = '';
          for(let i = 0 ; i < this.cateValue.length ; i ++) {
            if(this.cateValue[i].length === 0) {
              break;
            }
            txt += ">" + this.cateValue[i].NAME;
          }
          txt = txt.substring(1);
          return txt;
        },
        TreeInfoExtra(Tree, node, parentNode, depth) {
            for(let i = 0 ; i < Tree.length ; i ++)  {
                let treeNode = Tree[i];
                if(parentNode.hasOwnProperty("PKEY")) {
                    treeNode[`depth${depth-1}`] = parentNode;
                }
                if(treeNode.child !== undefined) {
                    let child = JSON.parse(JSON.stringify(treeNode.child));
                    // delete treeNode.child;
                    this.TreeInfoExtra(child, node, treeNode, depth + 1);
                } else {
                    treeNode['KeyList'] = [];
                    treeNode['ItemList'] = [];
					let cnt = treeNode.depth - 1;
                    // let cnt = treeNode.depth
					let nodes = JSON.parse(JSON.stringify(treeNode));
                    treeNode['KeyList'].push(treeNode.PKEY);
                    treeNode['ItemList'].push(JSON.parse(JSON.stringify(treeNode)));
                    while(cnt > 0) {
                        nodes = nodes[`depth${cnt-1}`];
                        treeNode['KeyList'].push(nodes.PKEY);
                        treeNode['ItemList'].push(JSON.parse(JSON.stringify(nodes)));
                        cnt --;
                    }
                    node[treeNode.PKEY] = treeNode;
                }
          }
        },

    }
}